import { ButtonAPI, DatePickerAPI, FieldAPI, FormAPI } from '@philips-internal/oswald-ui-components';
import Controller, { OnBeforeSubmit, OnCancel, OnChange, OnClick, OnMount, OnValidate } from '@philips-internal/oswald-ui-core/lib/client';
import { Inject } from '@odinjs/odin';
import { ContextType, SubmittableFragmentContext } from '@philips-internal/oswald-ui-core/lib/component/context';
import { ChangeEvent, MountEvent, SubmitEvent, ValidateEvent } from '@philips-internal/oswald-ui-core/lib/component/types';
import { FragmentNames } from '../../codegen';
import { AppointmentCreationChooseAnotherDateAliases } from '../../codegen';
import BaseController from '../BaseController';
import { PredefinedValidators } from '../../utils/predefined-validators';
import moment from 'moment';
import { Value } from '@philips-internal/oswald-ui-core';

@Controller({component: AppointmentCreationChooseAnotherDateAliases.LAYOUT_APPOINTMENT_CHOOSE_ANOTHER_DATE, fragment: FragmentNames.APPOINTMENT_CREATION_CHOOSE_ANOTHER_DATE})
class AppointmentCreationChooseAnotherDateController extends BaseController {

  @Inject(ContextType.SUBMITTABLE_FRAGMENT)
    submittableFragmentContext!: SubmittableFragmentContext;

  @Inject(AppointmentCreationChooseAnotherDateAliases.BUTTON_CHOOSE_ANOTHER_DATE_SAVE)
    buttonChooseAnotherDateSave!: ButtonAPI;

  @Inject(AppointmentCreationChooseAnotherDateAliases.FIELD_AVAILABLE_PERIOD)
    datePickerAppointmentFieldAPI!: FieldAPI;

  @Inject(AppointmentCreationChooseAnotherDateAliases.FORM_CHOOSE_ANOTHER_DATE)
    formChooseAnotherDateAPI!: FormAPI;

  @Inject(AppointmentCreationChooseAnotherDateAliases.DATE_PICKER_APPOINTMENT_RANGE)
    datePickerChooseAnotherDateAPI!: DatePickerAPI;

  @OnBeforeSubmit({ target: AppointmentCreationChooseAnotherDateAliases.FORM_CHOOSE_ANOTHER_DATE })
  handleOnSubmitForm(event: SubmitEvent): void {
    this.submittableFragmentContext.submit(new SubmitEvent({ record: event.record }));
  }

  @OnCancel({ target: AppointmentCreationChooseAnotherDateAliases.FORM_CHOOSE_ANOTHER_DATE })
  handleOnCancel(): void {
    this.submittableFragmentContext.cancel(new SubmitEvent());
  }

  @OnChange({ target: AppointmentCreationChooseAnotherDateAliases.DATE_PICKER_APPOINTMENT_RANGE })
  handleOnChangeDatePicker(event: ChangeEvent<string[]>): void {
    if (!event || !event.value) {
      this.datePickerAppointmentFieldAPI.addValidator(PredefinedValidators.required());
    } else {
      this.datePickerAppointmentFieldAPI.removeValidator(PredefinedValidators.required().name);
    }

    this.formChooseAnotherDateAPI.validate();
  }

  @OnMount({ target: AppointmentCreationChooseAnotherDateAliases.DATE_PICKER_APPOINTMENT_RANGE })
  handleOnMountDatePicker(): void {
    const today = moment().utc();
    const initialDate = today.day(today.day() - 1).toISOString();
    const finalDate = moment().year(0).month(1).day(1).toISOString();
    this.datePickerChooseAnotherDateAPI.clearRanges();
    this.datePickerChooseAnotherDateAPI.setInitialDate(initialDate);
    this.datePickerChooseAnotherDateAPI.addRange(finalDate, initialDate);
  }

  @OnClick({ target: AppointmentCreationChooseAnotherDateAliases.BUTTON_CHOOSE_ANOTHER_DATE_CANCEL })
  handleOnClickCancel(): void {
    this.formChooseAnotherDateAPI.cancel();
  }

  @OnClick({ target: AppointmentCreationChooseAnotherDateAliases.BUTTON_CHOOSE_ANOTHER_DATE_SAVE })
  handleOnClickSave(): void {
    this.formChooseAnotherDateAPI.submit();
  }

  @OnMount({ target: AppointmentCreationChooseAnotherDateAliases.FORM_CHOOSE_ANOTHER_DATE })
  handleMountForm(event: MountEvent): void {
    const formApi = event.target as FormAPI;
    const data = formApi.getValue();

    const suggestionFirstItem = this.context.get('suggestionFirstItem') as Record<string, Value>;
    const selectedDate = moment(suggestionFirstItem.date as string);
    data[this.datePickerAppointmentFieldAPI.getEntry()] = selectedDate.utc().toISOString();

    formApi.setValue(data);
  }

  @OnValidate({ target: AppointmentCreationChooseAnotherDateAliases.FORM_CHOOSE_ANOTHER_DATE })
  handleOnValidadeChooseAnotherDate(event: ValidateEvent): void {
    this.buttonChooseAnotherDateSave.setEnabled(event.valid);
  }
}
export default AppointmentCreationChooseAnotherDateController;